import axios from "axios";
import { isTokenExpired, getNewToken, getToken } from "helpers/auth";

export const getCompanyInfo = async (params) => {
  const DEFAULT_PAGE_SIZE = 10;
  const url = `${process.env.EJ_APPS_SEARCH_API}/search/v1/project/company-projects?pageSize=${DEFAULT_PAGE_SIZE}`;
  const response = await axios.post(
    url,
    {
      application: "desktop-web",
      ...params,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export async function makeShortUrl(payload, token) {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/panel/v1/urls/shorten`;
  const response = await axios.post(
    url,
    {
      application: "desktop-web",
      ...payload,
    },
    {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Accept: "application/json",
        Authorization: token,
      },
    }
  );
  return response.data;
}

export const getCompanyContract = async () => {
  if (isTokenExpired()) await getNewToken();
  const authorization = await getToken();
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/panel/v1/account/contract?contractType=COMPANY_CONTRACT`;
  const response = await axios.get(url, {
    headers: {
      Authorization: authorization,
    },
  });
  return response.data;
};

export const getTTYBStatus = async () => {
  if (isTokenExpired()) await getNewToken();
  const authorization = await getToken();
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/panel/v1/profile/check-ttyb`;
  const response = await axios.get(url, {
    headers: {
      Authorization: authorization,
    },
  });
  return response.data;
};

export const sendTTYBNumber = async (ttybNumber) => {
  if (isTokenExpired()) await getNewToken();
  const authorization = await getToken();
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/panel/v1/profile/ttyb`;
  const response = await axios.put(
    url,
    {
      ttybNumber,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: authorization,
      },
    }
  );
  return response.data;
};

export const approveContracts = async (id) => {
  if (isTokenExpired()) await getNewToken();
  const authorization = await getToken();
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/panel/v1/account/contract/approve`;
  const response = await axios.put(
    url,
    {
      contractIds: [id],
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: authorization,
      },
    }
  );
  return response.data;
};

export const sendCompanyContactForm = async (query) => {
  const url = `${window.env.EJ_APPS_CMS_HOSTNAME}/api/v1/contact/`;
  const response = await axios.post(
    url,
    {
      ...query,
    },
    {
      headers: {
        "Content-Type": "application/json",
        "X-From-Channel": "DESKTOP_WEB",
      },
    }
  );
  return response.data;
};
